import React from "react";
import Section from "components/common/Section";
import Link from "gatsby-link";
import SalaryImage from "./assets/salary.jpg";
import LookupImage from "./assets/lookup.jpg";
import SalaryImage2x from "./assets/2x/salary.jpg";
import LookupImage2x from "./assets/2x/lookup.jpg";

import "./ProjectSections.scss";

const ProjectSection = ({ name, description, className = "", href, imageSrc, imageSrc2x }) => {
	return (
		<Section
			className={`projectSection ${className}`}
			includeVerticalPadding={false}
		>
			<div className="sectionHeader text-align-center">
				<div className="title font-size-large">
					{name}
				</div>
				<div className="subText font-size-base description line-height-large font-family-open-sans">
					{description}
				</div>
				<Link to={href} className="caseStudyLink font-color-red font-size-base">
					See case study
					<span className="nextArrow" />
				</Link>
			</div>
			<Link to={href} >
				<div className="sectionImageContainer text-align-center has-mobile-gutter desktop-max-width-base">
					<img className="border-radius-small" src={imageSrc} srcSet={`${imageSrc2x} 2x`} />
				</div>
			</Link>
		</Section>
	);
};

export const LinkedInSalarySection = () => (
	<ProjectSection
		name="LinkedIn Salary"
		description="Bringing salary transparency to help professionals understand their earning potential"
		className="linkedInSalary"
		href="/salary"
		imageSrc={SalaryImage}
		imageSrc2x={SalaryImage2x}
	/>
);

export const LinkedInLookupSection = () => (
	<ProjectSection
		name="LinkedIn Lookup"
		description="Helping employees research, contact and get insights about their coworkers"
		className="linkedInLookup"
		href="/lookup"
		imageSrc={LookupImage}
		imageSrc2x={LookupImage2x}
	/>
);

export default () => [
	<LinkedInSalarySection key="salary" />,
	<LinkedInLookupSection key="lookup" />,
];



// WEBPACK FOOTER //
// ./src/components/pages/index/ProjectSections.js